import type {PermissionType} from '@hconnect/apiclient'
import {useUserContext} from '@hconnect/login'

import {useSettingsQuery} from '../../../common/providers'
import type {PermissionParsed} from '../../types'

const selector = (permissionTypes: PermissionType[]) => (permissions: PermissionParsed[]) =>
  permissions.filter((entry) => permissionTypes.includes(entry.permissionType))

export const usePermissionsQuery = (permissionTypes?: PermissionType[]) => {
  const {loggedUser} = useUserContext()
  if (!loggedUser) throw new Error('Login details data is missing!')
  const userId = loggedUser.user_id
  return useSettingsQuery('permissions', [userId], {
    select: permissionTypes ? selector(permissionTypes) : undefined
  })
}
